/**
 * Imports a page dynamically based on the provided page name.
 *
 * @param {string} pageName - The name of the page to import.
 * @return {Function} A function that returns a promise which resolves to the imported page component.
 */
function importPage(pageName) {
    return () => import(`@/pages/${pageName}.vue`).then((m) => m.default || m);
}

function importPageFromDir(dirName, pageName) {
    return () =>
        import(`@/pages/${dirName}/${pageName}.vue`).then(
            (m) => m.default || m,
        );
}

export { importPage, importPageFromDir };
